import React, { useState,useEffect} from "react";
import axios from 'axios';
import styled from "styled-components";
import AirportMenu from "./AirportMenu"

    
const AirportListBox = styled.div`
    display:flex;
    max-height:20%;
    flex: 0 1 auto;
    flex-direction:column;
`;


const SearchBoxDiv=styled.div`
    display: flex;
    color:black;
    background:#DCE8F7;
    justify-content: space-between;
    align-items: center;
    padding-left: 3.4rem;
    list-style: none;
    height: 40px;
    text-decoration: none;
    font-size: 18px;
`;
const AirportSearch=({menuRef, selectedIndex, airportDataList,activeAirport,setActiveAirport,activeMetric,setActiveMetric,
          setMetricSelectedIndex,summaryMetricName,summaryMetricIndex,enabledAirports,handleClick,currentUser})=>{
  const [displayAirportList, setDisplayAirportList] = useState([]);
  const [displayAirportCityList, setDisplayAirportCityList] = useState([]);
  useEffect(()=>{
    var disableRefList = Array.from(Array(Object.keys(airportDataList).length).keys())
    if(Object.hasOwn(enabledAirports,activeMetric)){
        var orderRef = disableRefList.map(
                            (ref,index)=> enabledAirports[activeMetric].includes(
                                    Object.keys(airportDataList)[index])?-1:ref)
        console.log(orderRef.keys())
        var indices = Array.from(orderRef.keys()).sort( (a,b) => orderRef[a]- orderRef[b]);

        var sortedAirportList = indices.map(i => Object.keys(airportDataList)[i])
        var sortedAirportCityList = indices.map(i => Object.keys(airportDataList).map((airport) =>airportDataList[airport]['city'])[i])
        setDisplayAirportList(sortedAirportList);
        setDisplayAirportCityList(sortedAirportCityList);
    }else{
      setDisplayAirportList(Object.keys(airportDataList))
      setDisplayAirportCityList(Object.keys(airportDataList).map((airport) =>airportDataList[airport]['city']))
    }

  },[airportDataList,activeMetric]);
  // useEffect(() => {
  //   axios.get('http://localhost:8000/api/get-swans-airports/')
  //     .then(response => {
  //       var airportData = response.data.message
  //       setAirportDataList(airportData);
  //       setDisplayAirportList(Object.keys(airportData))
  //       setDisplayAirportCityList(Object.keys(airportData).map((airport) =>airportData[airport]['city']))
  //     })
  //     .catch(error => {
  //       console.log(error);
  //     });
  // }, []);

    
  function updateDisplayAirportList(e){
         if(e.target.value.trim() !==''){
         setDisplayAirportList(Object.keys(airportDataList).filter((airport) => {
             return ((airport.toUpperCase().startsWith(e.target.value.trim().toUpperCase()))||
                    (airportDataList[airport]['city'].toUpperCase().startsWith(e.target.value.trim().toUpperCase())))
             }))
         setDisplayAirportCityList(Object.keys(airportDataList).filter((airport) => {
             return ((airport.toUpperCase().startsWith(e.target.value.trim().toUpperCase()))||
                    (airportDataList[airport]['city'].toUpperCase().startsWith(e.target.value.trim().toUpperCase())))
                        
             }).map((airport) => airportDataList[airport]['city']))
             
         }
         else{
             setDisplayAirportList(Object.keys(airportDataList))
             setDisplayAirportCityList(Object.keys(airportDataList).map((airport) => airportDataList[airport]['city']))
         };
    }
  return(
    <>
    <SearchBoxDiv>
      <input name="airportName" defaultValue={""} onChange={updateDisplayAirportList}>
      </input>
      </SearchBoxDiv>
    <AirportListBox>
        <AirportMenu
                airportList={displayAirportList}
                airportCityList={displayAirportCityList}
                key={0}
                menuRef={menuRef}
                selectedIndex={selectedIndex}
                activeMetric={activeMetric}
                activeAirport={activeAirport}
                setActiveAirport={setActiveAirport}
                setActiveMetric={setActiveMetric}
                setMetricSelectedIndex={setMetricSelectedIndex}
                summaryMetricName={summaryMetricName}
                summaryMetricIndex={summaryMetricIndex}
                enabledAirports={enabledAirports}
                handleClick={handleClick}
                currentUser={currentUser}
        />
    
        </AirportListBox>    
    </>
  );
};
export default AirportSearch;
